import { FetchResult } from 'apollo-boost';

import { smartFiltersQuery } from '../../graphql/queries/grid/domain';
import { GdSmartFiltersContainerInput, GdStatPresetInput, SmartFiltersQuery } from '../../typings/graphql-grid';
import { GroupId } from '../../typings/groups';
import { BaseDataProvider } from '../BaseDataProvider/BaseDataProvider';

export const mapToSmartFiltersApiInput = (
    campaignsIds: Array<string>,
    groupsIds?: Array<GroupId>
): GdSmartFiltersContainerInput => {
    return {
        filter: {
            adGroupIdIn: groupsIds,
            campaignIdIn: campaignsIds
        },
        limitOffset: {
            offset: 0,
            limit: 10000
        },
        statRequirements: {
            preset: GdStatPresetInput.TODAY
        }
    };
};

export class SmartFiltersDataProvider extends BaseDataProvider {
    public getSmartFilters = (
        campaignsIds: Array<string>,
        login: string,
        groupsIds?: Array<GroupId>
    ): Promise<FetchResult<SmartFiltersQuery>> => {
        return this.createQuery<SmartFiltersQuery>(smartFiltersQuery, {
            variables: {
                smartFiltersInput: mapToSmartFiltersApiInput(campaignsIds, groupsIds),
                login
            }
        });
    };
}
